import { render } from "./ProfilePage.vue?vue&type=template&id=4027c0a5"
import script from "./ProfilePage.vue?vue&type=script&lang=js"
export * from "./ProfilePage.vue?vue&type=script&lang=js"

import "./ProfilePage.vue?vue&type=style&index=0&id=4027c0a5&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__